export default __webpack_public_path__ + "static/char-v-36-9b41dc71ca29191fc413857760ef0257.webp";